import * as $ from "jquery";

import { ColumnMode, SelectionType } from "@swimlane/ngx-datatable";
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  atLeastOneLanguageValidator,
  marketingImageRequiredValidator,
} from "../marketing-configuration-form.utils";

import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { BsModalService } from "ngx-bootstrap/modal";
import { MarketingConfigurationServices } from "src/app/_services/marketingConfiguration.service";
import { DiscardChangesComponent } from "src/app/dashboard/shared-components/discard-changes/discard-changes.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";
import { configImage } from "src/app/_config/config";
import { languages } from "src/app/_config/personal-assistant/common";

@Component({
  selector: "app-add-yacht-marketing",
  templateUrl: "./add-yacht-marketing.component.html",
  styleUrls: ["./add-yacht-marketing.component.scss"],
})
export class AddYachtMarketingComponent implements OnInit {
  loading = false;
  public ColumnMode = ColumnMode;
  public screenWidth: number;
  public datatableResponsive = false;
  public marketingConfigurationForm: FormGroup;
  public modalRef: BsModalRef;
  checkCircle = configImage.checkCircle;
  uploadIcon = configImage.uploadIcon;
  public disableCreateBtn = false;
  public disableUpdateBtn = true;
  closeResult: string;
  @Output() dataEmitter: EventEmitter<any> = new EventEmitter();

  @Input() configurationData: any;
  @ViewChild("successYachtMarketingPopup")
  successYachtMarketingPopup: TemplateRef<any>;
  title: string = "Add";
  
  private currentType: string = "YACHT";

  imagePathURL: any;
  public img64: any;
  public uploadfile: string;
  public uploadfileThumbnail: any;
  public thumbnailPathUrl: string;

  public tenantId: any;
  public languages = languages;

  private hasMarketingImage(): boolean {
    const thumbEl = $("#thumbnail")[0] as HTMLInputElement | undefined;
    const hasNewFile = !!(thumbEl?.files && thumbEl.files.length > 0);
    return !!(this.imagePathURL || this.uploadfile || this.uploadfileThumbnail || hasNewFile);
  }

  private getFormValidators() {
    return [
      atLeastOneLanguageValidator("imageTitle_"),
      atLeastOneLanguageValidator("description_"),
      atLeastOneLanguageValidator("ctaText_"),
      marketingImageRequiredValidator(() => this.hasMarketingImage()),
    ];
  }

  constructor(
    private marketingConfigurationServices: MarketingConfigurationServices,
    private formBuilder: FormBuilder,
    private modalService: BsModalService,
    public modal: NgbModal,
    public toastrService: ToastrService,
    public translate: TranslateService
  ) {
    this.onResize();
  }
  @HostListener("window:resize", ["$event"])
  onResize() {
    this.screenWidth = window.innerWidth;
    if (this.screenWidth <= 991) {
      this.datatableResponsive = true;
    } else {
      this.datatableResponsive = true;
    }
  }
  ngOnInit(): void {
    if (this.configurationData && (this.configurationData?.marketingId || this.configurationData?._id || this.configurationData?.id)) {
      this.title = "Edit";
      if (this.configurationData?.image) {
        this.imagePathURL = this.configurationData.image;
      }
      // For edit mode, use the existing type from configurationData
      this.currentType = this.configurationData.type || "YACHT";
    }
    
    const marketingId = this.configurationData?.marketingId || this.configurationData?._id || this.configurationData?.id;
    
    const ctaValue =
      this.configurationData?.cta === "OPEN_YACHT"
        ? this.configurationData.cta
        : "OPEN_YACHT";
    const orderValue =
      this.configurationData?.order !== undefined &&
      this.configurationData?.order !== null
        ? this.configurationData.order
        : null;
    
    // Get multi-language data from configurationData
    const imageTitleInLanguage = this.configurationData?.imageTitleInLanguage || {};
    const descriptionInLanguage = this.configurationData?.descriptionInLanguage || {};
    const ctaTextInLanguage = this.configurationData?.ctaTextInLanguage || {};
    
    if (marketingId) {
      this.marketingConfigurationForm = this.formBuilder.group({
        _id: [marketingId],
        image: [""],
        ...this.languages
          .map((l) => l.key)
          .reduce((controls, lang) => {
            controls[`imageTitle_${lang}`] = [
              imageTitleInLanguage[lang] || "",
              [Validators.minLength(1), Validators.maxLength(30)],
            ];
            return controls;
          }, {}),
        ...this.languages
          .map((l) => l.key)
          .reduce((controls, lang) => {
            controls[`description_${lang}`] = [descriptionInLanguage[lang] || ""];
            return controls;
          }, {}),
        cta: [
          ctaValue,
          [Validators.required],
        ],
        order: [orderValue, [Validators.required]],
        status: [this.configurationData?.status || "ACTIVE", [Validators.required]],
        ...this.languages
          .map((l) => l.key)
          .reduce((controls, lang) => {
            controls[`ctaText_${lang}`] = [
              ctaTextInLanguage[lang] || "",
              [Validators.maxLength(30)],
            ];
            return controls;
          }, {}),
      }, {
        validators: this.getFormValidators(),
      });
    } else {
      this.marketingConfigurationForm = this.formBuilder.group({
        image: [""],
        ...this.languages
          .map((l) => l.key)
          .reduce((controls, lang) => {
            controls[`imageTitle_${lang}`] = [
              "",
              [Validators.minLength(1), Validators.maxLength(30)],
            ];
            return controls;
          }, {}),
        ...this.languages
          .map((l) => l.key)
          .reduce((controls, lang) => {
            controls[`description_${lang}`] = [""];
            return controls;
          }, {}),
        cta: [
          "OPEN_YACHT",
          [Validators.required],
        ],
        order: [null, [Validators.required]],
        status: ["ACTIVE", [Validators.required]],
        ...this.languages
          .map((l) => l.key)
          .reduce((controls, lang) => {
            controls[`ctaText_${lang}`] = ["", [Validators.maxLength(30)]];
            return controls;
          }, {}),
      }, {
        validators: this.getFormValidators(),
      });
    }
    this.marketingConfigurationForm.updateValueAndValidity();
  }

  _handleReaderLoadedThumbnail(e) {
    const reader = e.target;
    const base64result = reader.result;
    this.img64 = base64result;
  }

  public picked(event, type) {
    const sizeByte = $("#thumbnail")[0].files[0].size;
    const sizeKb = sizeByte / 1024;

    const extension: string = $("#thumbnail").val().replace(/^.*\./, "");
    const ext: string = extension.toUpperCase();

    if (ext !== "JPG" && ext !== "JPEG" && ext !== "PNG") {
      $("#file_detail").html("File format should be (JPG/JPEG and PNG)");
      if (type === "create") {
        this.disableCreateBtn = true;
      } else {
        this.disableUpdateBtn = true;
      }
    } else if (sizeKb > 500) {
      $("#file_detail").html("File size maximum 500KB");
      if (type === "create") {
        this.disableCreateBtn = true;
      } else {
        this.disableUpdateBtn = true;
      }
    } else {
      $("#file_detail").html("");
      this.disableCreateBtn = false;
      this.disableUpdateBtn = false;
      const fileList: FileList = event.target.files;

      if (fileList.length > 0) {
        const file: File = fileList[0];
        const reader = new FileReader();
        reader.onload = () => {
          this.imagePathURL = reader.result as string;
        };
        reader.onloadend = this._handleReaderLoadedThumbnail.bind(this);
        reader.readAsDataURL(file);
        this.handleInputChange(file, type);
        this.marketingConfigurationForm?.updateValueAndValidity();
      } else {
        alert("No file selected");
      }
    }
  }

  handleInputChange(files, type) {
    const file = files;

    const pattern = /image-*/;
    const reader = new FileReader();
    if (type === "create") {
      this.uploadfile = file.name;
      this.uploadfileThumbnail = "";
    } else {
      this.uploadfileThumbnail = file.name;
      this.uploadfile = "";
    }
    if (!file.type.match(pattern)) {
      alert("invalid format");
      return;
    }
    this.img64 = files;
  }

  addConfigurationSubmit(value) {
    this.marketingConfigurationForm.markAllAsTouched();
    this.marketingConfigurationForm.updateValueAndValidity();
    if (this.marketingConfigurationForm.invalid) {
      return;
    }
    // Transform multi-language fields to match DTO format
    const imageTitleInLanguage = this.languages.reduce((acc, lang) => {
      const langValue = value[`imageTitle_${lang.key}`];
      if (langValue && langValue.trim().length > 0) {
        acc[lang.key] = langValue.trim();
      }
      return acc;
    }, {});

    const descriptionInLanguage = this.languages.reduce((acc, lang) => {
      const langValue = value[`description_${lang.key}`];
      if (langValue && langValue.trim().length > 0) {
        acc[lang.key] = langValue.trim();
      }
      return acc;
    }, {});

    const ctaTextInLanguage = this.languages.reduce((acc, lang) => {
      const langValue = value[`ctaText_${lang.key}`];
      if (langValue && langValue.trim().length > 0) {
        acc[lang.key] = langValue.trim();
      }
      return acc;
    }, {});

    const marketingConfigurationPayload = {
      type: this.currentType,
      imageTitleInLanguage: Object.keys(imageTitleInLanguage).length > 0 ? imageTitleInLanguage : undefined,
      descriptionInLanguage: Object.keys(descriptionInLanguage).length > 0 ? descriptionInLanguage : undefined,
      cta: value.cta,
      order: Number(value.order),
      status: value.status,
      ctaTextInLanguage: Object.keys(ctaTextInLanguage).length > 0 ? ctaTextInLanguage : undefined,
    };
    this.loading = true;
  
    const marketingId = this.configurationData?.marketingId || this.configurationData?._id || this.configurationData?.id;
    if (marketingId) {
      const formData = new FormData();

      // Append image file if a new one is selected
      if ($("#thumbnail")[0].files && $("#thumbnail")[0].files.length > 0) {
        formData.append(
          "image",
          $("#thumbnail")[0].files[0],
          $("#thumbnail")[0].files[0].name
        );
      }

      // Function to recursively append nested objects to formData
      const appendFormData = (formData: FormData, obj: any, parentKey: string = "") => {
        for (const key in obj) {
          if (obj.hasOwnProperty(key)) {
            const newKey = parentKey ? `${parentKey}[${key}]` : key;
            const value = obj[key];

            if (value && typeof value === "object" && !Array.isArray(value)) {
              appendFormData(formData, value, newKey); // Recursively append objects
            } else {
              formData.append(newKey, value); // Append leaf values
            }
          }
        }
      };

      // Append other form fields
      for (const key in marketingConfigurationPayload) {
        if (marketingConfigurationPayload[key] !== undefined && marketingConfigurationPayload[key] !== null) {
          const payloadValue = marketingConfigurationPayload[key];
          if (typeof payloadValue === "object" && !Array.isArray(payloadValue)) {
            // If the value is an object, we need to flatten it
            appendFormData(formData, payloadValue, key); // Flatten the nested object
          } else {
            formData.append(key, payloadValue); // Otherwise, just append the value
          }
        }
      }

      this.marketingConfigurationServices
        .updateMarketingConfiguration(formData, marketingId)
        .subscribe(
          (res: any) => {
            this.loading = false;
            this.modalRef = this.modalService.show(this.successYachtMarketingPopup, {
              class: "custom-success-car-modal modal-dialog-centered",
            });
            this.closeForm({ isSuccess: true });
          },
          (error) => {
            this.loading = false;
            setTimeout(() => {
              if (!error.error.message) {
                this.toastrService.error(
                  this.translate.instant("errors.connectionError"),
                  ""
                );
              } else {
                this.toastrService.error(error.error.message, "");
              }
            }, 1000);
          }
        );
    } else {
      const formData = new FormData();

      // Append image file
      if ($("#thumbnail")[0].files && $("#thumbnail")[0].files.length > 0) {
        formData.append(
          "image",
          $("#thumbnail")[0].files[0],
          $("#thumbnail")[0].files[0].name
        );
      }

      // Function to recursively append nested objects to formData
      const appendFormData = (formData: FormData, obj: any, parentKey: string = "") => {
        for (const key in obj) {
          if (obj.hasOwnProperty(key)) {
            const newKey = parentKey ? `${parentKey}[${key}]` : key;
            const value = obj[key];

            if (value && typeof value === "object" && !Array.isArray(value)) {
              appendFormData(formData, value, newKey); // Recursively append objects
            } else {
              formData.append(newKey, value); // Append leaf values
            }
          }
        }
      };

      // Append other form fields
      for (const key in marketingConfigurationPayload) {
        if (marketingConfigurationPayload[key] !== undefined && marketingConfigurationPayload[key] !== null) {
          const payloadValue = marketingConfigurationPayload[key];
          if (typeof payloadValue === "object" && !Array.isArray(payloadValue)) {
            // If the value is an object, we need to flatten it
            appendFormData(formData, payloadValue, key); // Flatten the nested object
          } else {
            formData.append(key, payloadValue); // Otherwise, just append the value
          }
        }
      }
      this.marketingConfigurationServices.createMarketingConfiguration(formData).subscribe(
        (res) => {
          this.loading = false;
          this.modalRef = this.modalService.show(this.successYachtMarketingPopup, {
            class: "custom-success-car-modal modal-dialog-centered",
          });
          this.closeForm({ isSuccess: true });
        },
        (error) => {
          this.loading = false;
          setTimeout(() => {
            if (!error.error.message) {
              this.toastrService.error(
                this.translate.instant("errors.connectionError"),
                ""
              );
            } else {
              this.toastrService.error(error.error.message, "");
            }
          }, 1000);
        }
      );
    }
  }

  closeForm(data = null) {
    this.marketingConfigurationForm.reset();
    this.dataEmitter.emit(data);
    this.modal.dismissAll(data);
  }
  discardChanges() {
    this.modal.open(DiscardChangesComponent, {
      scrollable: true,
      windowClass: "discard-modal",
    });
  }
}

